/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, createRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import MultiRangeSlider from "multi-range-slider-react";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import {
  getAllConnectivity,
  getAllLanguage,
  getAllVoiceType,
  getDirector,
  getEngineer,
  getAllCountry,
  getAllCity,
  getAllState,
  getProducer,
  getRecordingstudio,
  getAgent,
  getUserDetailsById,
  getUserManagementByEdit,
  getVoiceTalent,
  AddSuperLooper,
  AddHallofFame,
  AddCourtesy,
  DeleteCourtesy,
  DeleteSuperLooper,
  DeleteHallOfFame,
} from "../../api";
import { useSelector } from "react-redux";
import Select from "react-select";
import { UserDetailsSchema } from "../../schema";

const EditUserDetails = ({ id }) => {
  const { profileData, token } = useSelector((state) => state.profileReducer);
  const [isAgnet, setIsAgent] = useState(false);
  const [user, setUser] = useState();
  const [minValue, setMinValue] = useState(25);
  const [maxValue, setMaxValue] = useState(75);
  const [isAgentEmailInput, setIsEmailAgentInput] = useState(false);
  const [isAgentTelephoneInput, setIsAgentTelephone] = useState(false);
  const toast = useRef(null);
  const [serviceData, setServiceData] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCoun, setSelectedCoun] = useState("");
  const [selectedCounCode, setSelectedCounCode] = useState("");
  const [selectedStat, setSelectedStat] = useState("");
  const [selectedStatCode, setSelectedStatCode] = useState("");
  const [image, setImage] = useState("");
  const [cropData, setCropData] = useState("#");
  const cropperRef = createRef();
  const [previewImg, setPreviewImg] = useState(null);
  const [disableHOF, setDisableHOF] = useState(null);
  const [disableCourtesy, setDisableCourtesy] = useState(null);

  const moment = require("moment");

  const initialValues = {
    uploadimg: "",
    UserEmail: user ? user?.email : "",
    firstName: user ? user?.first_name : "",
    lastName: user ? user?.last_name : "",
    experience: user ? user?.experience : "",
    gender: user ? user?.gender : "",
    minValue: user ? user?.min_age : "",
    maxValue: user ? user?.max_age : "",
    country: user ? user?.country_code : "",
    state: user ? user?.state_code : " ",
    city: user ? user?.city : "",
    voice_languages: [],
    chosenLanguage: user
      ? user?.voice_languages?.map((ele) => {
        return { id: ele.id, value: ele.name_en, label: ele.name_en };
      })
      : [],
    voice_types: [],
    chosenVoice: user
      ? user?.voice_types?.map((ele) => {
        return { id: ele.id, value: ele.name_en, label: ele.name_en };
      })
      : [],
    user_type: user ? user?.type : "",
    user_role: user ? user?.role : "",
    facebook: user ? user?.facebook : "",
    instagram: user ? user?.instagram : "",
    website: user ? user?.website : "",
    agent_name: user ? user?.agent_name : "",
    agency_name: user ? user?.agency_name : "",
    agent_telephone: user ? user?.agent_telephone : " ",
    agent_website: user ? user?.gent_website : "",
    agent_email: user ? user?.agent_email : " ",
    address: user ? user?.agent_address : " ",
    speciality: [],
    specialityChosen:
      user && Array.isArray(user?.specialties)
        ? user?.specialties?.map((ele) => {
          return { id: ele.id, value: ele.name_en, label: ele.name_en };
        })
        : [],
    badge_status: user ? user?.badges : " ",
    union: user ? user?.union : "",
    home_studio: user ? user?.home_studio : "",
    Connectivity: [],
    chosenConnectivity: user
      ? user?.connectivities?.map((ele) => {
        return { id: ele.id, value: ele.name_en, label: ele.name_en };
      })
      : [],
    discoverable: user ? user?.discoverable : "",

    superLooperStatus: user ? user?.superLooperStatus : "",
    hallOfFameStatus: user ? user?.hallOfFameStatus : "",
    courtesy: user && user?.courtesy !== null ? user?.courtesy : "",

    superlooperbio:
      user && user.superLooperStatus
        ? user && user.superLooperStatus.paragraphs
        : "",
    hallOfFameBio:
      user && user.hallOfFameStatus
        ? user && user.hallOfFameStatus.paragraphs
        : "",

    halloffamedropdown: user ? user?.hallOfFameStatus?.status : "",
    selectedCheckbox:
      user && user.hallOfFameStatus && user.superLooperStatus
        ? ["Hall of Fame", "Super Looper"]
        : user && user.superLooperStatus
          ? ["Super Looper"]
          : user && user.hallOfFameStatus
            ? ["Hall of Fame"]
            : [],
  };

  const convertBase64ToImage = (uri) => {
    const splitDataURI = uri.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const type = splitDataURI[0].split(":")[1].split(";")[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i += 1)
      ia[i] = byteString.charCodeAt(i);

    const imageBlob = new Blob([ia], { type });
    const imageFile = new File([imageBlob], "live-pic.jpeg", { type });
    return imageFile;
  };

  const editUserHandler = async (values) => {
    const formData = new FormData();
    let croppedImage;
    if (cropData !== "#") {
      croppedImage = convertBase64ToImage(cropData);
      if (!croppedImage) {
        return;
      }
    } else {
      croppedImage = values.uploadimg;
    }
    formData.append("profile_pic", croppedImage);
    formData.append("first_name", values.firstName);
    formData.append("email", values.UserEmail);
    formData.append("last_name", values.lastName);
    formData.append("experience", values.experience);
    formData.append("gender", values.gender);
    formData.append("min_age", minValue);
    formData.append("max_age", maxValue);

    formData.append("country", selectedCoun);
    formData.append("country_code", selectedCounCode);
    formData.append("state", selectedStat);
    formData.append("state_code", selectedStatCode);
    formData.append("city", values.city);

    formData.append(
      "voice_languages",
      values.chosenLanguage?.map((ele) => ele.id).join(",")
    );
    formData.append(
      "voice_types",
      values.chosenVoice?.map((ele) => ele.id).join(",")
    );
    formData.append("type", values.user_type);
    formData.append("role", values.user_role);
    formData.append("facebook", values.facebook);
    formData.append("instagram", values.instagram);
    formData.append("website", values.website);
    formData.append("agent_name", values.agent_name);
    formData.append("agency_name", values.agency_name);
    formData.append("agent_telephone", values.agent_telephone);
    formData.append("agent_website", values.website1);
    formData.append("agent_email", values.agent_email);
    formData.append("address", values.agent_address);
    formData.append(
      "specialties",
      values.specialityChosen?.map((ele) => ele.id).join(",")
    );
    formData.append("badges", values.badge_status);
    formData.append("union", values.union);
    formData.append("home_studio", values.home_studio);
    formData.append(
      "connectivities",
      values.chosenConnectivity?.map((ele) => ele.id).join(",")
    );
    formData.append("discoverable", values.discoverable);
    formData.append("agent", isAgnet);

    if (values.selectedCheckbox.includes("Hall of Fame")) {
      const hallofFamePayload = {
        userId: user?.id,
        paragraphs: values.hallOfFameBio,
        status: values.halloffamedropdown,
        author: profileData?.first_name + " " + profileData?.last_name,
        month: moment().month() + 1,
        year: moment().year(),
      };
      AddHallofFame(hallofFamePayload, token)
        .then((res) => {
          // toast.current.show({
          //   severity: "success",
          //   summary: `${res?.data?.message}`,
          // });
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
    if (values.selectedCheckbox.includes("Super Looper")) {
      const superLooperPayload = {
        userId: user?.id,
        paragraphs: values.superlooperbio,
      };
      AddSuperLooper(superLooperPayload, token)
        .then((res) => {
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: `${err?.response?.data?.message}`,
          });
          const arr = values.selectedCheckbox.filter(
            (ele) => ele !== "Super Looper"
          );
          setFieldValue("selectedCheckbox", arr);
        });
    }
    await getUserManagementByEdit(id, formData, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.message}`,
        });
      });
  };

  const zoomIn = () => {
    const cropper = cropperRef.current.cropper;
    cropper.zoom(0.1);
  };

  // Function to handle zoom out
  const zoomOut = () => {
    const cropper = cropperRef.current.cropper;
    cropper.zoom(-0.1);
  };

  const getUserdata = () => {
    getUserDetailsById(id, token)
      .then((res) => {
        // toast.current.show({severity: 'success', summary: `${res?.data?.message}`});
        const user = res?.data?.data?.[0];
        setUser(user);
        setPreviewImg(user?.profile_pic);
        setServiceData(res?.data?.data);
        setSelectedCoun(user?.country);
        setSelectedCounCode(user?.country_code);
        setSelectedStat(user?.state);
        setSelectedStatCode(user?.state_code);
        setMinValue(user.min_age);
        setMaxValue(user.max_age);
        onUserTypeChangeHandler(user.type);
        setDisableCourtesy(user && user.hallOfFameStatus ? true : false);
        setDisableHOF(user && user.hallOfFameStatus ? false : true);
        if (res) {
          setServiceData(res?.data?.data);
        }
      })
      .catch((err) => { });
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    handleBlur,
  } = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: UserDetailsSchema(
      isAgentEmailInput,
      isAgentTelephoneInput
    ),
    onSubmit: (values) => editUserHandler(values),
  });

  const handleOnChange = (e, setFieldValue, setFieldTouched, values) => {
    if (e.target.files.length) {
      setFieldValue(e.target.name, e?.target?.files[0], true);
    } else {
      setFieldValue(e.target.name, values[e.target.name]);
    }
  };

  const handleImageUpload = (e, setImage) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
    if (e.target.files.length) {
      const reader = new FileReader();
      reader.onload = () => {
        convertBase64ToImage(reader.result);

        setFieldValue("image", file);
      };
      reader.readAsDataURL(file);
    }
  };

  // const onsaveimage = async (id) => {
  //   const formData = new FormData();
  //   if (image) formData.append("image", image);
  //   await getUserManagementByEdit(
  //     id,
  //     formData,
  //     token
  //     // {
  //     //   userId: serviceData?.userId
  //     //     .split(",")
  //     //     .filter((ele) => ele !== Userid)
  //     //     .join(),
  //     //     image: image1
  //     // },
  //   )
  //     .then((res) => {
  //       setIsLoading(false);
  //       // toast.current.show({
  //       //   severity: "success",
  //       //   summary: `${res?.data?.message}`,
  //       // });
  //       setTimeout(() => {
  //         // navigate("event-management/EventDetails");
  //       }, 2000);
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       toast.current.show({
  //         severity: "error",
  //         summary: `${err?.response?.data?.message}`,
  //       });
  //     });
  // };

  // languages
  const getLanguages = async () => {
    getAllLanguage(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("voice_languages", arr);
      })
      .catch((err) => { });
  };

  const getVoiceType = async () => {
    getAllVoiceType(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("voice_types", arr);
      })
      .catch((err) => { });
  };

  const getConnectivity = async () => {
    getAllConnectivity(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("Connectivity", arr);
      })
      .catch((err) => { });
  };

  const getVoiceTalentData = async () => {
    getVoiceTalent(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => { });
  };

  const getProducerData = async () => {
    getProducer(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => { });
  };

  const getDirectorData = async () => {
    getDirector(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => { });
  };

  const getAgentData = async () => {
    getAgent(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => { });
  };

  const getEngineerData = async () => {
    getEngineer(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => { });
  };

  const getRecordingStudioData = async () => {
    getRecordingstudio(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => { });
  };

  const onUserTypeChangeHandler = async (val) => {
    setFieldValue("user_type", val);
    setFieldValue("specialityChosen", []);
    switch (val) {
      case "voicetalent":
        await getVoiceTalentData();
        setIsAgent(false);
        break;
      case "producer":
        await getProducerData();
        setIsAgent(false);
        break;
      case "director":
        await getDirectorData();
        setIsAgent(false);
        break;
      case "agent":
        await getAgentData();
        setIsAgent(true);
        break;
      case "engineer":
        await getEngineerData();
        setIsAgent(false);
        break;
      case "recordingstudio":
        await getRecordingStudioData();
        setIsAgent(false);
        break;
      default:
        break;
    }
  };

  const onAgentEmailChange = (val) => {
    setFieldValue("agent_email", val);
    setIsEmailAgentInput(true);
  };

  const onAgentTeleChange = (val) => {
    setFieldValue("agent_telephone", val);
    setIsAgentTelephone(true);
  };

  const fetchCountries = async () => {
    await getAllCountry(token).then((res) => {
      setIsLoading(false);
      setCountries(res?.data?.data);
    });
  };

  const handleCountryChange = (isoCode) => {
    const countryObj = countries.find((ele) => ele.isoCode === isoCode);
    setSelectedCoun(countryObj.name);
    setSelectedCounCode(isoCode);
    fetchStates(isoCode);
    setFieldValue("country", isoCode);
  };

  const fetchStates = async (selectedCountryId) => {
    await getAllState(selectedCountryId, token).then((res) => {
      setIsLoading(false);
      setStates(res?.data?.data);
    });
  };

  const handleStateChange = (isoCode) => {
    const stateobj = states.find((ele) => ele.isoCode === isoCode);
    setSelectedStat(stateobj.name);
    setSelectedStatCode(isoCode);
    fetchCities(isoCode, values.country);
    setFieldValue("state", isoCode);
  };

  const fetchCities = async (stateId, countryCode) => {
    await getAllCity(stateId, countryCode, token).then((res) => {
      setIsLoading(false);
      setCities(res?.data?.data);
    });
  };

  const onSuperLooperChangeHandler = (e) => {
    const idx = values.selectedCheckbox.indexOf(e.target.value);
    const checkboxValue = e.target.value;

    setFieldValue("selectedCheckbox", [
      ...values.selectedCheckbox,
      checkboxValue,
    ]);
    if (idx === -1) {

      if (checkboxValue === "Hall of Fame") {
        if (e.target.checked) {
          setDisableHOF(false)
          setDisableCourtesy(true); 
        }
        else {
          setDisableHOF(false)
          setDisableCourtesy(false);
        }
        const payload = {
          userId: user?.id,
          author: profileData?.first_name + " " + profileData?.last_name,
          month: moment().month() + 1,
          year: moment().year(),
          paragraphs: values.hallOfFameBio,
          status: values.halloffamedropdown,
        };
        AddHallofFame(payload, token)
          .then((res) => {
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      } else if (checkboxValue === "Super Looper") {
        const payload = {
          userId: user?.id,
          author: profileData?.first_name + " " + profileData?.last_name,
          month: moment().month() + 1,
          year: moment().year(),
          paragraphs: values.superlooperbio,
        };
        AddSuperLooper(payload, token)
          .then((res) => {
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
    } else {
      const arr = values.selectedCheckbox.filter((ele) => ele !== checkboxValue);
      setFieldValue("selectedCheckbox", arr);
      if (checkboxValue === "Hall of Fame") {
        if (e.target.checked) {
          setDisableHOF(false)
          setDisableCourtesy(true); 
        }
        else {
          setDisableHOF(false)
          setDisableCourtesy(false);
        }
        DeleteHallOfFame(user?.hallOfFameStatus.id, token)
          .then((res) => {
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      } else if (checkboxValue === "Super Looper") {
        DeleteSuperLooper(user?.superLooperStatus?.id, token)
          .then((res) => {
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
    }
    // condition for courtesy
    if (e.target.checked) {
      if (checkboxValue === "courtesy") {
        setDisableHOF(true);
        setDisableCourtesy(false);
        AddCourtesy(user?.id, token) // AddCourtesy requires the user ID and token
          .then((res) => {
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
    } else {
      if (checkboxValue === "courtesy") {
        setDisableHOF(false);
        setDisableCourtesy(false);
        DeleteCourtesy(user?.id, token) // DeleteCourtesy requires the courtesy ID and token
          .then((res) => {
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
          });
      }
    }
  }
  const onChange = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    if (files[0].size >= 10 * 1048576) {
      setImage(null);
      toast.current.show({
        severity: "error",
        summary: "File size should be less than 10MB",
      });
      setIsActive(false);
      return false;
    } else {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
    }
  };

  useEffect(() => {
    async function getAllAPI() {
      await fetchCountries();
      await fetchStates(user?.country_code);
      await fetchCities(user?.state_code, user?.country_code);
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    async function getAllAPI() {
      await getLanguages();
      await getVoiceType();
      await getConnectivity();
      await getUserdata();
      await onUserTypeChangeHandler(values.user_type);
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isActive, setIsActive] = useState(false);

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const navigate = useNavigate();
  return (
    <>
      {isLoading && (
        <div class="set-proper-line-in-all-page">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <Toast ref={toast} />
      <div className="back-touserdetails">
        <div className="userprofile-pics">
          <form onSubmit={handleSubmit} class="">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <svg
                  onClick={() => {
                    navigate(-1);
                  }}
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="cursor-pointer"
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
                <h6 className="mb-0">Back to User Details</h6>
              </div>
            </div>

            <div className="main-profile-all-cls-start">
              <label className="profile-cls-text mt-4 mb-4">
                Profile Details
              </label>
              <div className="details-all-name upload-user-profile-cls">
                <div className="row">
                  <div className="col-lg-3 position-relative">
                    {previewImg && serviceData && (
                      <div className="text-centersall">
                        <img
                          src={
                            previewImg
                              ? previewImg
                              : require("../../assets/defaultImg.png")
                          }
                          alt="Preview1"
                        />
                      </div>
                    )}
                    <label className="my-2">Upload profile image</label>
                    <div className="cropping-img-cls-all">
                      <input
                        type="file"
                        onChange={
                          ((e) => handleImageUpload(e, setImage), onChange)
                        }
                        style={{ width: "100%" }}
                        onClick={toggleClass}
                        className="files-name-edit"
                      />
                    </div>

                    {/* <input
                      type="file"
                      name="uploadimg"
                      className="form-control set-to-auto-height"
                      accept="image/png, image/jpeg, image/jpg image/bmp"
                      id="exampleFormControlInput1"
                      placeholder="File Name"
                      onBlur={handleBlur}
                      // value={values.uploadimg}
                      onChange={(e) =>
                        handleOnChange(
                          e,
                          setFieldValue,
                          setFieldTouched,
                          values
                        )
                      }
                    ></input> */}
                    <span className="upload-all-btns-cls-add">
                      {/* <button
                        className="btn btn-primary uploading-btn-all-time-cls"
                        type="button"
                        >
                        Upload
                      </button> */}
                    </span>
                  </div>
                  <div className="col-lg-3">
                    <label className="my-2">
                      User Email<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="UserEmail"
                      id="exampleFormControlInput2"
                      placeholder="Enter Your Email"
                      value={values.UserEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.UserEmail && touched.UserEmail ? (
                      <p className="form-error">{errors.UserEmail}</p>
                    ) : null}
                  </div>

                  <div className="col-lg-3">
                    <label className="my-2">
                      First name<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="firstName"
                      id="exampleFormControlInput2"
                      placeholder="Enter First Name"
                      value={values.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.firstName && touched.firstName ? (
                      <p className="form-error">{errors.firstName}</p>
                    ) : null}
                  </div>

                  <div className="col-lg-3">
                    <label className="my-2">
                      Last Name<span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="lastName"
                      id="exampleFormControlInput3"
                      placeholder="Enter Last Name"
                      value={values.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.lastName && touched.lastName ? (
                      <p className="form-error">{errors.lastName}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row align-items-center">
                  <div
                    className={`col-lg-3 ${isActive ? "addspacingcls" : "removespacingcls"
                      }`}
                  >
                    <div className="cropper-set-properly">
                      <Cropper
                        type="file"
                        name="uploadimg"
                        className="form-control set-to-auto-height"
                        accept="image/png, image/jpeg, image/jpg image/bmp"
                        id="exampleFormControlInput1"
                        style={{ width: "100%", border: "none", padding: "0" }}
                        placeholder="File Name"
                        onBlur={handleBlur}
                        ref={cropperRef}
                        zoomTo={0.5}
                        zoomable={true}
                        initialAspectRatio={1}
                        preview=".img-preview"
                        src={image}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                        guides={true}
                        onChange={(e) =>
                          handleOnChange(
                            e,
                            setFieldValue,
                            setFieldTouched,
                            values
                          )
                        }
                      />

                      <div
                        className={` ${isActive
                            ? "proper-to-plus-minus"
                            : "removeproper-to-plus-minus"
                          }`}
                      >
                        <button
                          onClick={zoomIn}
                          className="zooming-in"
                          type="button"
                        >
                          <span className="zoomin">
                            <svg
                              width="18px"
                              height="18px"
                              viewBox="0 0 32 32"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                id="Page-1"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <g
                                  id="Icon-Set"
                                  transform="translate(-308.000000, -1139.000000)"
                                  fill="#000000"
                                >
                                  <path
                                    d="M321.46,1163.45 C315.17,1163.45 310.07,1158.44 310.07,1152.25 C310.07,1146.06 315.17,1141.04 321.46,1141.04 C327.75,1141.04 332.85,1146.06 332.85,1152.25 C332.85,1158.44 327.75,1163.45 321.46,1163.45 L321.46,1163.45 Z M339.688,1169.25 L331.429,1161.12 C333.592,1158.77 334.92,1155.67 334.92,1152.25 C334.92,1144.93 328.894,1139 321.46,1139 C314.026,1139 308,1144.93 308,1152.25 C308,1159.56 314.026,1165.49 321.46,1165.49 C324.672,1165.49 327.618,1164.38 329.932,1162.53 L338.225,1170.69 C338.629,1171.09 339.284,1171.09 339.688,1170.69 C340.093,1170.3 340.093,1169.65 339.688,1169.25 L339.688,1169.25 Z M326.519,1151.41 L322.522,1151.41 L322.522,1147.41 C322.522,1146.85 322.075,1146.41 321.523,1146.41 C320.972,1146.41 320.524,1146.85 320.524,1147.41 L320.524,1151.41 L316.529,1151.41 C315.978,1151.41 315.53,1151.59 315.53,1152.14 C315.53,1152.7 315.978,1153.41 316.529,1153.41 L320.524,1153.41 L320.524,1157.41 C320.524,1157.97 320.972,1158.41 321.523,1158.41 C322.075,1158.41 322.522,1157.97 322.522,1157.41 L322.522,1153.41 L326.519,1153.41 C327.07,1153.41 327.518,1152.96 327.518,1152.41 C327.518,1151.86 327.07,1151.41 326.519,1151.41 L326.519,1151.41 Z"
                                    id="zoom-in"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </span>
                        </button>
                        <button
                          onClick={() => zoomOut()}
                          className="zoom-out"
                          type="button"
                        >
                          <span className="zoomin">
                            <svg
                              width="18px"
                              height="18px"
                              viewBox="0 0 32 32"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                id="Page-1"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <g
                                  id="Icon-Set"
                                  transform="translate(-360.000000, -1139.000000)"
                                  fill="#000000"
                                >
                                  <path
                                    d="M373.46,1163.45 C367.17,1163.45 362.071,1158.44 362.071,1152.25 C362.071,1146.06 367.17,1141.04 373.46,1141.04 C379.75,1141.04 384.85,1146.06 384.85,1152.25 C384.85,1158.44 379.75,1163.45 373.46,1163.45 L373.46,1163.45 Z M391.688,1169.25 L383.429,1161.12 C385.592,1158.77 386.92,1155.67 386.92,1152.25 C386.92,1144.93 380.894,1139 373.46,1139 C366.026,1139 360,1144.93 360,1152.25 C360,1159.56 366.026,1165.49 373.46,1165.49 C376.672,1165.49 379.618,1164.38 381.932,1162.53 L390.225,1170.69 C390.629,1171.09 391.284,1171.09 391.688,1170.69 C392.093,1170.3 392.093,1169.65 391.688,1169.25 L391.688,1169.25 Z M378.689,1151.41 L368.643,1151.41 C368.102,1151.41 367.663,1151.84 367.663,1152.37 C367.663,1152.9 368.102,1153.33 368.643,1153.33 L378.689,1153.33 C379.23,1153.33 379.669,1152.9 379.669,1152.37 C379.669,1151.84 379.23,1151.41 378.689,1151.41 L378.689,1151.41 Z"
                                    id="zoom-out"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-lg-3 ${isActive ? "addspacingcls" : "removespacingcls"
                      }`}
                  >
                    <div className="first-side-btncrop m-auto text-center">
                      <button
                        onClick={getCropData}
                        className={`btn btn-primary box ${isActive ? "activeimg" : "boxadd"
                          }`}
                        type="button"
                      >
                        Crop Image
                      </button>
                    </div>
                  </div>
                  <div
                    className={`col-lg-3 ${isActive ? "addspacingcls" : "removespacingcls"
                      }`}
                  >
                    <div className="secondside-img">
                      <div className="box">
                        <div className="img-all-height-calc">
                          <img
                            alt=""
                            src={cropData}
                            className={`box ${isActive ? "activeimg" : "boxadd"
                              }`}
                            style={{
                              width: "auto",
                              objectFit: "contain",
                              height: "250px",
                              maxWidth: "100%",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="upload-user-profile-cls">
                <div className="row mt-4">
                  <div className="col-lg-3">
                    <label className="my-2">Gender</label>
                    <select
                      name="gender"
                      value={values.gender}
                      class="form-select"
                      aria-label="Default select example"
                      onChange={handleChange}
                      placeholder="Select Gender"
                    >
                      <option value="" disabled selected hidden>
                        Select Gender
                      </option>
                      <option value="1" label="Male">
                        Male
                      </option>
                      <option value="2" label="Female">
                        Female
                      </option>
                      <option value="3" label="Non-Binary">
                        Non-Binary
                      </option>
                    </select>
                  </div>
                  <div className="col-lg-3">
                    <label className="my-2">
                      {" "}
                      Country<span class="required">*</span>
                    </label>
                    <select
                      name="country"
                      value={values.country}
                      class="form-select"
                      aria-label="Default select example"
                      onChange={(e) => handleCountryChange(e.target.value)}
                      onBlur={handleBlur}
                      placeholder="Select Country"
                    >
                      <option value="" disabled selected hidden>
                        Select a Country
                      </option>
                      {countries.map((country) => (
                        <option key={country.isoCode} value={country.isoCode}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    {errors.country && touched.country ? (
                      <p className="form-error">{errors.country}</p>
                    ) : null}
                  </div>

                  <div className="col-lg-3">
                    <label className="my-2">
                      State<span class="required">*</span>
                    </label>
                    <select
                      name="state"
                      value={values.state}
                      class="form-select"
                      aria-label="Default select example"
                      onChange={(e) => handleStateChange(e.target.value)}
                      onBlur={handleBlur}
                      placeholder="Select State"
                    >
                      <option value="" disabled selected hidden>
                        Select a State
                      </option>
                      {states.map((state) => (
                        <option key={state.isoCode} value={state.isoCode}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                    {errors.state && touched.state ? (
                      <p className="form-error">{errors.state}</p>
                    ) : null}
                  </div>
                  <div className="col-lg-3">
                    <label className="my-2">
                      City<span class="required">*</span>
                    </label>
                    <select
                      name="city"
                      value={values.city}
                      class="form-select"
                      aria-label="Default select example"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Select City"
                    >
                      <option value="" disabled selected hidden>
                        Select a City
                      </option>
                      {cities.map((city) => (
                        <option key={city.id} value={city.id}>
                          {city.name}
                        </option>
                      ))}
                    </select>
                    {errors.city && touched.city ? (
                      <p className="form-error">{errors.city}</p>
                    ) : null}
                  </div>
                  <div className="row mt-3">
                    <div className="col-lg-2">
                      <label className="my-2">
                        Years of Experience<span class="required">*</span>
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        name="experience"
                        id="exampleFormControlInput2"
                        placeholder="Enter Years"
                        value={values.experience}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      ></input>
                      {errors.experience && touched.experience ? (
                        <p className="form-error">{errors.experience}</p>
                      ) : null}
                    </div>
                    {values.voice_languages && (
                      <div className="col-lg-3">
                        <label className="my-2">Languages</label>
                        <Select
                          name="chosenLanguage"
                          className="select-multiple-all-drop"
                          options={values.voice_languages}
                          placeholder="Select Voice Languages"
                          // defaultValue={user ? user?.voice_languages.map((ele) => { return {id: ele.id, value: ele.name_en, label: ele.name_en}}) : ""}
                          value={values.chosenLanguage}
                          isMulti
                          onChange={(selectedLanguages) => {
                            setFieldValue("chosenLanguage", selectedLanguages);
                          }}
                        />
                      </div>
                    )}
                    {values.voice_types && (
                      <div className="col-lg-4">
                        <label className="my-2">Voice Type</label>
                        <Select
                          name="chosenVoice"
                          options={values.voice_types}
                          placeholder="Select voice Type"
                          className="select-multiple-all-drop"
                          value={values.chosenVoice}
                          isMulti
                          onChange={(selectedVoiceType) => {
                            setFieldValue("chosenVoice", selectedVoiceType);
                          }}
                        />
                      </div>
                    )}
                    <div className="col-lg-3">
                      <label className="my-2">
                        User Type<span class="required">*</span>
                      </label>
                      <select
                        name="user_type"
                        value={values.user_type}
                        class="form-select"
                        aria-label="Default select example"
                        onChange={(e) =>
                          onUserTypeChangeHandler(e.target.value)
                        }
                        onBlur={handleBlur}
                      >
                        <option value="" disabled selected hidden>
                          Select User types
                        </option>
                        <option
                          value="voicetalent"
                          label="Voicetalent"
                          selected={user?.type === "voicetalent"}
                        >
                          Voice-talent
                        </option>
                        <option
                          value="producer"
                          label="Producer"
                          selected={user?.type === "producer"}
                        >
                          Producer
                        </option>
                        <option
                          value="director"
                          label="Director"
                          selected={user?.type === "director"}
                        >
                          Director
                        </option>
                        <option
                          value="agent"
                          label="Agent"
                          selected={user?.type === "agent"}
                        >
                          Agent
                        </option>
                        <option
                          value="engineer"
                          label="Engineer"
                          selected={user?.type === "engineer"}
                        >
                          Engineer
                        </option>
                        <option
                          value="recordingstudio"
                          label="Studio"
                          selected={user?.type === "recordingstudio"}
                        >
                          Recording-studio
                        </option>
                      </select>
                      {errors.user_type && touched.user_type ? (
                        <p className="form-error">{errors.user_type}</p>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className="upload-user-profile-cls">
                <div className="row mt-3">
                  <div className="col-lg-4">
                    <label className="my-2">
                      User Role<span class="required">*</span>
                    </label>
                    <select
                      name="user_role"
                      value={values.user_role}
                      class="form-select"
                      aria-label="Default select example"
                      onChange={handleChange}
                    >
                      <option value="" disabled selected hidden>
                        Select User Role
                      </option>
                      <option value="Admin" label="Admin">
                        Admin
                      </option>
                      <option value="User" label="User">
                        User
                      </option>
                      <option value="Ambassador" label="Ambassador">
                        Ambassador
                      </option>
                    </select>
                    {errors.user_role && touched.user_role ? (
                      <p className="form-error">{errors.user_role}</p>
                    ) : null}
                  </div>
                  <div className="col">
                    <div className="text-left">
                      <label className="my-2 mb-0">Select Age Value</label>

                      <div className="newmultirangslider-cls-add-custom">
                        <MultiRangeSlider
                          name="ageRange"
                          baseClassName="multi-range-slider-black"
                          minValue={minValue}
                          maxValue={maxValue}
                          placeholder="Select age"
                          value={values.chosenLanguage}
                          onInput={(e) => {
                            setMinValue(e.minValue);
                            setMaxValue(e.maxValue);
                          }}
                          onChange={(e) => {
                            setMinValue(e.minValue);
                            setMaxValue(e.maxValue);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 align-items-center">
                    <div className="col-lg-2">
                      <div className="checking-all">
                        <label className="d-flex align-items-center">
                          <input
                            name="selectedCheckbox"
                            type="checkbox"
                            checked={
                              values.selectedCheckbox.some(
                                (ele) => ele === "Super Looper"
                              )
                                ? true
                                : false
                            }
                            onChange={(e) => onSuperLooperChangeHandler(e)}
                            className="me-2"
                            value="Super Looper"
                          />
                          Super Looper
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="checking-all">
                        <label className="d-flex align-items-center">
                          <input
                            name="selectedCheckbox"
                            type="checkbox"
                            checked={
                              values.selectedCheckbox.some(
                                (ele) => ele === "Hall of Fame"
                              )
                                ? true
                                : false
                            }
                            onChange={(e) => onSuperLooperChangeHandler(e)}
                            className="me-2"
                            value="Hall of Fame"
                            disabled={disableHOF}
                          />
                          Hall of Fame
                        </label>
                      </div>
                    </div>
                    {user && (
                      <div className="col-lg-2">
                        <div className="checking-all">
                          <label className="d-flex align-items-center">
                            <input
                              name="selectedCheckbox"
                              type="checkbox"
                              defaultChecked={user && user?.courtesy !== null ? true : false}
                              onChange={(e) => onSuperLooperChangeHandler(e)}
                              className="me-2"
                              value="courtesy"
                              disabled={disableCourtesy}
                            />
                            {disableCourtesy}
                            Courtesy ($10)
                          </label>
                        </div>
                      </div>
                    )}
                    {values.selectedCheckbox.some(
                      (ele) => ele === "Hall of Fame"
                    ) && (
                        <>
                          <div className="col-lg-4">
                            <label className="my-2">
                              Type<span class="required">*</span>
                            </label>
                            <select
                              name="halloffamedropdown"
                              class="form-select"
                              value={values.halloffamedropdown}
                              aria-label="Default select example"
                              placeholder="Select Type"
                              onChange={handleChange}
                            >
                              <option value="" disabled selected hidden>
                                Select Type
                              </option>
                              <option value="1">Excellence - ($10)</option>
                              <option value="2">Silver - ($25)</option>
                              <option value="3">Gold - ($50)</option>
                              <option value="4">Founder - ($5)</option>
                            </select>
                          </div>
                          <div className="col-lg-4">
                            <label className="my-2">
                              Hall of Fame Bio/Description
                            </label>
                            <textarea
                              type="text"
                              class="form-control"
                              placeholder="Please Enter Paragraph Here"
                              name="hallOfFameBio"
                              id="floatingTextarea"
                              value={values.hallOfFameBio}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            ></textarea>
                          </div>
                        </>
                      )}
                  </div>
                  {values.selectedCheckbox.some(
                    (ele) => ele === "Super Looper"
                  ) && (
                      <div className="col-lg-4">
                        <label className="my-2">
                          Super Looper Bio/Description
                        </label>
                        <textarea
                          type="text"
                          class="form-control"
                          placeholder="Please Enter Paragraph Here"
                          name="superlooperbio"
                          id="floatingTextarea"
                          value={values.superlooperbio}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        ></textarea>
                      </div>
                    )}
                </div>
              </div>
              <hr />

              <div className="main-profile-all-cls-start">
                <label className="profile-cls-text mt-2 mb-4">
                  Socials Details
                </label>
                <div className="details-all-name upload-user-profile-cls">
                  <div className="row">
                    <div className="col-lg-4">
                      <label className="my-2">Facebook</label>
                      <input
                        type="text"
                        name="facebook"
                        class="form-control"
                        id="exampleFormControlInput1"
                        placeholder="Enter Your Facebook Username here"
                        value={values.facebook}
                        onChange={handleChange}
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="my-2">Instagram</label>
                      <input
                        type="text"
                        name="instagram"
                        class="form-control"
                        id="exampleFormControlInput2"
                        placeholder="Enter Your Instagram Username here"
                        value={values.instagram}
                        onChange={handleChange}
                      ></input>
                    </div>
                    <div className="col-lg-4">
                      <label className="my-2">Website</label>
                      <input
                        type="text"
                        name="website"
                        class="form-control"
                        id="exampleFormControlInput3"
                        placeholder="Enter Your Website Url here"
                        value={values.website}
                        onChange={handleChange}
                      ></input>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              {isAgnet && (
                <div className="main-profile-all-cls-start">
                  <label className="profile-cls-text mt-2 mb-4">
                    Agent Details
                  </label>
                  <div className="details-all-name upload-user-profile-cls">
                    <div className="row">
                      <div className="col-lg-4">
                        <label className="my-2">Agent Name</label>
                        <input
                          type="text"
                          name="agent_name"
                          class="form-control"
                          id="exampleFormControlInput1"
                          placeholder="File Name"
                          value={values.agent_name}
                          onChange={handleChange}
                        ></input>
                      </div>
                      <div className="col-lg-4">
                        <label className="my-2">Agency Name</label>
                        <input
                          type="text"
                          name="agency_name"
                          class="form-control"
                          id="exampleFormControlInput2"
                          placeholder="Write here"
                          value={values.agency_name}
                          onChange={handleChange}
                        ></input>
                      </div>
                      <div className="col-lg-4">
                        <label className="my-2">Telephone</label>
                        <input
                          type="number"
                          name="agent_telephone"
                          class="form-control"
                          id="exampleFormControlInput3"
                          placeholder="Telephone"
                          value={values.agent_telephone}
                          onChange={(e) => {
                            onAgentTeleChange(e.target.value);
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-lg-4">
                        <label className="my-2">Email</label>
                        <input
                          type="text"
                          name="agent_email"
                          class="form-control"
                          id="exampleFormControlInput1"
                          placeholder="File Name"
                          value={values.agent_email}
                          onChange={(e) => {
                            onAgentEmailChange(e.target.value);
                          }}
                        ></input>
                      </div>
                      <div className="col-lg-4">
                        <label className="my-2">Website</label>
                        <input
                          type="text"
                          name="website1"
                          class="form-control"
                          id="exampleFormControlInput2"
                          placeholder="Write here"
                          value={values.website1}
                          onChange={handleChange}
                        ></input>
                      </div>
                      <div className="col-lg-4">
                        <label className="my-2">Address</label>
                        <input
                          type="text"
                          name="agent_address"
                          class="form-control"
                          id="exampleFormControlInput3"
                          placeholder="Write here"
                          value={values.agent_address}
                          onChange={handleChange}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              )}

              <div className="main-profile-all-cls-start">
                <label className="profile-cls-text mt-2 mb-4">
                  Other Details
                </label>
                <div className="details-all-name upload-user-profile-cls">
                  <div className="row">
                    {values.speciality && (
                      <div className="col-lg-4">
                        <label className="my-2">Specialty</label>
                        <Select
                          name="specialityChosen"
                          options={values.speciality}
                          placeholder="Select speciality"
                          className="select-multiple-all-drop"
                          value={values.specialityChosen}
                          isMulti
                          onChange={(selectedSpeciality) => {
                            setFieldValue(
                              "specialityChosen",
                              selectedSpeciality
                            );
                          }}
                        />
                      </div>
                    )}

                    <div className="col-lg-4">
                      <label className="my-2">
                        Badge Status<span className="required">*</span>
                      </label>
                      <select
                        name="badge_status"
                        value={values.badge_status}
                        class="form-select"
                        aria-label="Default select example"
                        onChange={handleChange}
                        placeholder="Select Badge"
                        onBlur={handleBlur}
                      >
                        <option value="" selected hidden>
                          Select Badge
                        </option>
                        <option value="Silver" label="Silver">
                          Silver
                        </option>
                        <option value="Golden" label="Golden">
                          Golden
                        </option>
                        <option value="Platinum" label="Platinum">
                          Platinum
                        </option>
                      </select>
                      {errors.badge_status && touched.badge_status ? (
                        <p className="form-error">{errors.badge_status}</p>
                      ) : null}
                    </div>
                    <div className="col-lg-4">
                      <label className="my-2">Union/ Nonunion?</label>
                      <select
                        name="union"
                        value={values.union}
                        class="form-select"
                        aria-label="Default select example"
                        onChange={handleChange}
                        placeholder="Select any Option"
                      >
                        <option value="" disabled selected hidden>
                          Select any Option{" "}
                        </option>
                        <option value={true} label="Yes">
                          Yes
                        </option>
                        <option value={false} label="No">
                          No
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="col-lg-4">
                      <label className="my-2">Home Studio?</label>
                      <select
                        name="home_studio"
                        value={values.home_studio}
                        class="form-select"
                        aria-label="Default select example"
                        onChange={handleChange}
                        placeholder="Select any Option"
                      >
                        <option value="" disabled selected hidden>
                          Select Any Option
                        </option>
                        <option value="true" label="Yes">
                          Yes
                        </option>
                        <option value="false" label="No">
                          No
                        </option>
                      </select>
                    </div>
                    {values.Connectivity && (
                      <div className="col-lg-4">
                        <label className="my-2">Connectivity</label>
                        <Select
                          name="chosenConnectivity"
                          options={values.Connectivity}
                          placeholder="Select Connectivity"
                          className="select-multiple-all-drop"
                          value={values.chosenConnectivity}
                          isMulti
                          onChange={(selectedConnectivity) => {
                            setFieldValue(
                              "chosenConnectivity",
                              selectedConnectivity
                            );
                          }}
                        />
                      </div>
                    )}
                    <div className="col-lg-4">
                      <label className="my-2">Discoverable?</label>
                      <select
                        name="discoverable"
                        value={values.discoverable}
                        class="form-select"
                        aria-label="Default select example"
                        onChange={handleChange}
                        placeholder="Select Any Option"
                      >
                        <option value="" disabled selected hidden>
                          Select Any Option
                        </option>
                        <option value="true" label="Yes">
                          Yes
                        </option>
                        <option value="false" label="No">
                          No
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div className="right-sidebtn-add text-end">
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    onClick={() => {
                      navigate(-1);
                    }}
                    type="button"
                    className="btn btn-primary outline-btn-cls me-2"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary filled-btn-cls"
                  // onClick={() => onsaveimage(id)}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
            {/* </div>
            </div> */}
          </form>
        </div>
      </div>
    </>
  );
};

export default EditUserDetails;
